@if (showNav()) {
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer mode="side" opened class="sidenav">
      <mat-toolbar class="brand-bar">Panakyc</mat-toolbar>
      <mat-nav-list>
        @for (link of links; track link.path) {
          <a
            mat-list-item
            [routerLink]="link.path"
            routerLinkActive="active"
            [attr.aria-label]="link.label + ' link'"
          >
            <mat-icon matListItemIcon>{{ link.icon }}</mat-icon>
            <span matListItemTitle>{{ link.label }}</span>
          </a>
        }
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <mat-toolbar class="topbar">
        <button
          mat-icon-button
          (click)="drawer.toggle()"
          class="mobile-toggle"
          aria-label="Toggle menu"
        >
          <mat-icon>menu</mat-icon>
        </button>
        <span class="title">Panakyc Admin</span>
        <span class="spacer"></span>
        @if (currentUser(); as user) {
          <span class="user-label">{{ user.email }}</span>
        }
        <button mat-stroked-button type="button" (click)="logout()">Sign out</button>
      </mat-toolbar>

      <div class="content"><router-outlet></router-outlet></div>
    </mat-sidenav-content>
  </mat-sidenav-container>
} @else {
  <div class="content-no-nav"><router-outlet></router-outlet></div>
}
